// src/components/Header/Header.jsx
import React from "react";
import "./Header.css";
import logo from "../../assets/images/logo.png"; // ⬅️ Ajoutez cette ligne pour importer l'image

function Header() {
  return (
    <header className="header">
      <div className="logo">
        {/* ⬅️ L'image et le texte sont maintenant ensemble */}
        <img src={logo} alt="Logo de NEXUS SOLUTIONS" className="logo-img" />
        <span className="logo-text">NEXUS SOLUTIONS</span>
      </div>
      <div className="location">📍 Cocody, Angré, Cité des Racines</div>
    </header>
  );
}

export default Header;